/**
 * Created by jv on 2019-10-07 (16:10).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import InvestmentSlider from "Sources/components/game/components/investment-slider";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");

require("Styles/components/investment-card.scss");
require("Styles/components/business-model-dialog.scss");
require("Styles/components/investment-extra-dialog.scss");

class InvestmentExtraDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("investment-extra-dialog-");

    this.type = options.type;
    this.investment = options.investment;
    this.extraData = options.extraData;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;

    this.onExtraProductSelected = options.onExtraProductSelected;
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog investment-extra-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(this.investment)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up investment extra dialog card for type - %s", this.investment.type);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $investmentExtraContent = $("<div class='ied__content'></div>");
      $investmentExtraContent.addClass(`ied__type-${this.investment.type}`);

      let $contentTop = $("<div class='ied__top'></div>");

      let icon = InvestmentSlider.getIconCardForInvestment(this.investment.type, false)
      let $icon = $("<div class='ied__icon'></div>");
      if (utils.isNotNull(icon)) {
        $icon.append(icon);
      }

      $contentTop.append($icon);
      $contentTop.append(`<h4 class="ied__title">${InvestmentExtraDialog.getTitleForType(this.investment.type)}</h4>`);

      let $contentBottom = $("<div class='ied__bottom'></div>");

      let $eventDataHtml = this.getHtmlForInvestmentExtra();

      if (utils.isNotNull($eventDataHtml)) {
        $contentBottom.append($eventDataHtml);
      }

      $investmentExtraContent.append($contentTop);
      $investmentExtraContent.append($contentBottom);

      $dialogContent.append($investmentExtraContent);

      this.setUpEventListeners();
    }
  }

  static getTitleForType(type) {
    return LanguageManager.getValueForKey(`serious_game.business_model.investments.extra.titles.${type}`);
  }

  getHtmlForInvestmentExtra() {
    if (this.investment.type === "subsidy") {
      return InvestmentExtraDialog.getSubsidyHtml(this.investment, this.extraData.subsidyApproved);
    } else if (this.investment.type === "extraproduct") {
      return InvestmentExtraDialog.getExtraProductHtml(this.investment, this.extraData.extraProductIcons);
    }

    return null;
  }

  show() {
    this.renderDialogContent();
    this.$dialog.modal("show");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  disableProductButtons(flag) {
    this.$dialog.find(".ied__product").prop("disabled", flag);
  }

  setUpDialogEventListeners() {

  }

  setUpEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });

    this.$dialog.find(".ied__product").on("click", (e) => {
      let $this = $(e.delegateTarget);
      let productType = $this.data("extra-product");

      if (utils.isFunction(this.onExtraProductSelected)) {
        this.onExtraProductSelected.call(this.callbackContext, productType);
      }
    });
  }

  static getExtraProductHtml(extraProductInvestment, icons) {
    let $investmentExtraHtml = $("<div class='ied__data-wrapper'></div>");

    $investmentExtraHtml.append(`<p>${LanguageManager.getValueForKey("serious_game.business_model.investments.extra.content.extraproduct1")}</p>`);

    let $extraProducts = $("<div class='ied__products-wrapper'></div>");

    for (let i = 0; i < icons.length; i++) {
      let icon = icons[i];
      let $icon = $(`<div class='ied__product'><div class="ied__product-icon"><img src="${icon.value}" alt="${icon.type}"/></div></div>`);
      $icon.data("extra-product", icon.type);

      $extraProducts.append($icon);
    }

    $investmentExtraHtml.append($extraProducts);

    return $investmentExtraHtml;
  }

  static getSubsidyHtml(subsidyInvestment, approved) {
    let $investmentExtraHtml = $("<div class='ied__data-wrapper'></div>");

    $investmentExtraHtml.append(`<p class="text-center">${LanguageManager.getValueForKey("serious_game.business_model.investments.extra.content.subsidy.shared")}</p>`);

    if (approved) {
      $investmentExtraHtml.append(`<p class="mt-5 text-uppercase font-weight-medium">${LanguageManager.getValueForKey("serious_game.business_model.investments.extra.content.subsidy.approved")}</p>`);

      let $subsidyDataGroup = $("<div class='ied__data-group'></div>");
      $subsidyDataGroup.append(`<div class='ied__data-value ic-data ic-data__budget'>${subsidyInvestment.income}</div>`);
      $subsidyDataGroup.append(`<div class='ied__data-value ic-data ic-data__points'>${subsidyInvestment.points}</div>`);

      $investmentExtraHtml.append($subsidyDataGroup);
    } else {
      $investmentExtraHtml.append(`<p class="mt-5 text-uppercase font-weight-medium">${LanguageManager.getValueForKey("serious_game.business_model.investments.extra.content.subsidy.denied")}</p>`);
    }

    return $investmentExtraHtml;
  }
}

export default InvestmentExtraDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/investment-extra-dialog.js